import { createContext } from 'react';
import type { UseQueryResult } from 'react-query';
import type { IntegrationToken } from '../../domains/integrations/model';
import type {
  BaseSite,
  SiteWithAccess,
  SiteWithFeature,
  Feature,
  FeatureGroup,
} from '../../domains/site/model';
import type { SegmentTrackData, SiteGroupingData } from '../../domains/tracking/model';

export interface GlobalFilterContextObject {
  useTrackResult?: {
    // eslint-disable-next-line func-params-args/func-params, @typescript-eslint/no-explicit-any
    click: (eventName: string, uiPosition: string, groupData: any, additionalData?: any) => void;
    getGroupDataForSite: (site: BaseSite) => SiteGroupingData | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPermissionLevelForSite: (site: SiteWithAccess) => any | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    track: (eventName: string, properties?: SegmentTrackData) => void;
  };
  useTrafficCoverageResult?: {
    coveragePercentage: number | undefined;
  };
  isAllowed?: (feature: Feature, site: (BaseSite & SiteWithFeature) | null) => boolean;
  getMinimumFeatureGroupForFeature?: (featureName: Feature) => FeatureGroup;
  // Technically it comes from feedback package but as it has a circular dependency with webapp
  // we have to consider it's from webapp
  isAllowedForAsk?: (feature: Feature, site: SiteWithFeature | null) => boolean;
  hasFilterSavePermission?: boolean;
  useFeatureFlag?: (feature: string) => boolean;
  // Technically it comes from integrations package but as it has a circular dependency with webapp
  // we have to consider it's from webapp
  useIntegrationTokens?: (siteId: string) => UseQueryResult<IntegrationToken[], Error>;
}

export const GlobalFilterContextObject = createContext<GlobalFilterContextObject>({});
